import React from 'react';

import { useNavigate } from 'react-router-dom';

import JumbotronDescription from '@/components/ui/box/JumbotronDescription';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle';
import Button from '@/components/ui/buttons/Button';

import styles from './AcceptErrorContent.module.scss';

type Props = {
  title: string;
  description: NonNullable<React.ReactNode>;
};

const AcceptErrorContent: React.FC<Props> = ({ title, description }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.AcceptErrorContent}>
      <div className={styles.AcceptErrorContent__Content}>
        <JumbotronTitle>{title}</JumbotronTitle>
        <JumbotronDescription>{description}</JumbotronDescription>
        <Button
          className={styles.AcceptErrorContent__Content__Button}
          color="primary"
          type="button"
          onClick={() => {
            navigate('/mypage/profile');
          }}
        >
          マイページへ
        </Button>
      </div>
    </div>
  );
};

export default AcceptErrorContent;
